import script from "./LlTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./LlTextarea.vue?vue&type=script&setup=true&lang=js"

import "./LlTextarea.vue?vue&type=style&index=0&id=6965205a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6965205a"]])

export default __exports__